export const transactionClientActionTypes = {
  START_ADD_TRANSACTION_CLIENT: "START_ADD_TRANSACTION_CLIENT",
  ADD_TRANSACTION_CLIENT_SUCCESS: "ADD_TRANSACTION_CLIENT_SUCCESS",
  ADD_TRANSACTION_CLIENT_FAILURE: "ADD_TRANSACTION_CLIENT_FAILURE",

  START_GET_AND_VALIDATE_CLIENT_CLIENT: "START_GET_AND_VALIDATE_CLIENT_CLIENT",
  GET_AND_VALIDATE_CLIENT_CLIENT_SUCCESS: "GET_AND_VALIDATE_CLIENT_CLIENT_SUCCESS",
  GET_AND_VALIDATE_CLIENT_CLIENT_FAILURE: "GET_AND_VALIDATE_CLIENT_CLIENT_FAILURE",

  START_RESEND_ACCESS_CODE: "START_RESEND_ACCESS_CODE",
  RESEND_ACCESS_CODE_SUCCESS: "RESEND_ACCESS_CODE_SUCCESS",
  RESEND_ACCESS_CODE_FAILURE: "RESEND_ACCESS_CODE_FAILURE",

  START_VALIDATE_CLIENT_ACCESS_CODE: "START_VALIDATE_CLIENT_ACCESS_CODE",
  VALIDATE_CLIENT_ACCESS_CODE_SUCCESS: "VALIDATE_CLIENT_ACCESS_CODE_SUCCESS",
  VALIDATE_CLIENT_ACCESS_CODE_FAILURE: "VALIDATE_CLIENT_ACCESS_CODE_FAILURE",
};
